import React from 'react';
import { RecoilState, useRecoilState } from 'recoil';
import { GridProps } from '@tq/ui-components';

import { MultiSelect } from 'components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { ValueLabelResponse } from 'types';

export type ConsultationFilterMultiSelectProps = {
  label: string;
  items?: ValueLabelResponse[];
  state: RecoilState<ValueLabelResponse[]>;
  fieldId?: string;
  disabled?: boolean;
};

export const ConsultationFilterMultiSelect: React.FC<
  ConsultationFilterMultiSelectProps & GridProps
> = ({ label, disabled = false, items, state, ...stylingProps }) => {
  const isMobile = useIsMobile();
  const [selectedItems, setSelectedItems] = useRecoilState(state);

  const handleSelect = (value: string) => {
    const selectedValue = items?.find((item) => item.value === +value);
    if (
      !selectedValue ||
      selectedItems.find((selectedItem) => selectedItem.value === +value)
    ) {
      return;
    }
    setSelectedItems([...selectedItems, selectedValue]);
  };

  const handleRemoveSelection = (value: number | string) => {
    setSelectedItems(selectedItems.filter((item) => item.value !== value));
  };

  return (
    <MultiSelect
      disabled={disabled}
      label={`${label}:`}
      items={items}
      selectedItems={selectedItems}
      handleSelect={handleSelect}
      handleRemoveSelection={handleRemoveSelection}
      isInModal={isMobile}
      {...stylingProps}
    />
  );
};
